import React, { useEffect, useRef, useState } from "react";
import dayjs from "dayjs";
import { DatePicker } from "antd";

/* Date pill shared by the Canchas and Beauty agendas (and the Canchas table filter):
   trigger button + panel with quick picks and the Ant calendar. Styles are the
   `ef-date-pill-*` rules in reservas-organizer.css. */

const EFCalendarIcon = () => (
	<svg
		width="15"
		height="15"
		viewBox="0 0 15 15"
		fill="none"
		style={{ flexShrink: 0 }}
	>
		<rect
			x="0.5"
			y="1.5"
			width="14"
			height="12"
			rx="2"
			stroke="currentColor"
			strokeWidth="1.3"
		/>
		<path d="M0.5 5.5h14" stroke="currentColor" strokeWidth="1.3" />
		<path
			d="M4.5 0v3M10.5 0v3"
			stroke="currentColor"
			strokeWidth="1.3"
			strokeLinecap="round"
		/>
	</svg>
);

export const EFDatePill = ({
	value,
	onChange,
	placeholder = "dd/mm/aaaa",
	disabled = false,
	ariaLabel,
	displayFormat = "DD/MM/YYYY",
}) => {
	const [panelOpen, setPanelOpen] = useState(false);
	const [tempDate, setTempDate] = useState(null);
	const [calContainer, setCalContainer] = useState(null);
	const wrapRef = useRef(null);
	const djsVal = value ? dayjs(value) : null;
	const hasVal = djsVal && djsVal.isValid();

	useEffect(() => {
		if (panelOpen) setTempDate(hasVal ? djsVal : null);
	}, [panelOpen]); // eslint-disable-line

	useEffect(() => {
		if (!panelOpen) return;
		const handler = (e) => {
			if (wrapRef.current?.contains(e.target)) return;
			if (e.target.closest?.(".ant-picker-dropdown")) return;
			setPanelOpen(false);
		};
		document.addEventListener("mousedown", handler);
		return () => document.removeEventListener("mousedown", handler);
	}, [panelOpen]);

	const handleApply = () => {
		onChange(tempDate);
		setPanelOpen(false);
	};

	return (
		<div ref={wrapRef} className="ef-date-pill-wrap">
			<button
				type="button"
				className={`ef-date-pill-trigger${hasVal ? " has-value" : ""}`}
				onClick={() => !disabled && setPanelOpen((v) => !v)}
				disabled={disabled}
				aria-expanded={panelOpen}
				aria-label={ariaLabel}
			>
				<EFCalendarIcon />
				<span className="ef-date-pill-label">
					{hasVal ? djsVal.format(displayFormat) : placeholder}
				</span>
			</button>
			{panelOpen && (
				<div className="ef-date-pill-panel">
					<div className="ef-pill-panel-head">Elegir fecha</div>
					<div className="ef-pill-quick-row">
						<button
							type="button"
							className="ef-pill-quick"
							onClick={() => setTempDate(dayjs())}
						>
							HOY
						</button>
						<button
							type="button"
							className="ef-pill-quick"
							onClick={() => setTempDate(dayjs().add(1, "day"))}
						>
							MAÑANA
						</button>
						<button
							type="button"
							className="ef-pill-quick"
							onClick={() => setTempDate(dayjs().add(7, "day"))}
						>
							ESTA SEMANA
						</button>
					</div>
					<div ref={setCalContainer} className="ef-pill-cal-host">
						{calContainer && (
							<DatePicker
								open={true}
								value={tempDate}
								onChange={(d) => setTempDate(d)}
								format="DD/MM/YYYY"
								allowClear={false}
								getPopupContainer={() => calContainer}
								popupClassName="ef-pill-cal-popup"
								className="ef-pill-hidden-input"
								inputReadOnly
							/>
						)}
					</div>
					<div className="ef-pill-panel-actions">
						<button
							type="button"
							className="ef-pill-action"
							onClick={() => setTempDate(null)}
						>
							Limpiar
						</button>
						<button
							type="button"
							className="ef-pill-action"
							onClick={() => setPanelOpen(false)}
						>
							Cerrar
						</button>
						<button
							type="button"
							className="ef-pill-action ef-pill-action--primary"
							onClick={handleApply}
						>
							Aplicar
						</button>
					</div>
				</div>
			)}
		</div>
	);
};

export default EFDatePill;
